import { keyframes } from 'styled-components';

// TODO: move this to the theme
// eslint-disable-next-line import/prefer-default-export
export const FadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/animations.js